import fitvids from 'fitvids';
import stickyMeta from './scripts/modules/sticky-meta';
import stickyHeader from './scripts/modules/sticky-header';
import mobileMenu from './scripts/modules/mobile-menu';
import gallerySlider from './scripts/modules/gallery-slider';
import searchMenu from './scripts/modules/search-menu';
import siteNotice from './scripts/modules/site-notice';
import activeSubMenuScroller from './scripts/modules/active-sub-menu';
import assignCustomClass from './scripts/modules/columns';
import './scripts/modules/animated-number-counter';
import './scripts/modules/google-map';
import './scripts/modules/dropdown';
import './styles/style.scss';
import './scripts/modules/search';
import './scripts/modules/interactive-map-listener';
import './scripts/modules/accordion';
import './scripts/modules/external-links';
import './scripts/modules/annual-funds';

fitvids();
stickyMeta();
stickyHeader();
mobileMenu();
gallerySlider();
searchMenu();
siteNotice();
activeSubMenuScroller();
assignCustomClass();
